import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "16",
  height: "10",
  viewBox: "0 0 17 10",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  class: "fillPath",
  "fill-rule": "evenodd",
  "clip-rule": "evenodd",
  d: "M16.094.227a.5.5 0 0 1 0 .707l-6.76 6.76a.5.5 0 0 1-.708 0L5.46 4.527.854 9.134a.5.5 0 0 1-.708-.707l4.96-4.96a.5.5 0 0 1 .708 0L8.98 6.633 15.386.227a.5.5 0 0 1 .708 0Z",
  fill: "#F59600"
}, null, -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("path", {
  class: "fillPath",
  "fill-rule": "evenodd",
  "clip-rule": "evenodd",
  d: "M16.163.146a.5.5 0 0 1 .147.37L16.22 3.2l-.1 2.67a.5.5 0 1 1-1-.038l.1-2.668v-.002l.072-2.143-2.143.072-2.67.1a.5.5 0 1 1-.038-1l2.672-.1 2.68-.09a.5.5 0 0 1 .37.146Z",
  fill: "#F59600"
}, null, -1)
const _hoisted_4 = [
  _hoisted_2,
  _hoisted_3
]

function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_4]))
}
export default { render };